// 💾 src/components/transactions/TransactionsList.tsx
import { useEffect, useState } from "react"
import { auth } from "../../../../../services/firebase"
import "./style/TransactionsList.scss"

type Transaction = {
  id: string
  type: string
  coin: string
  amount: number
  date: string
}

type UserTransactions = {
  uid: string
  transactions: Transaction[]
}

const TransactionsList = () => {
  const user = auth.currentUser
  const [transactions, setTransactions] = useState<Transaction[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string>("")

  useEffect(() => {
    const fetchData = async () => {
      if (!user) {
        setError("Not signed in")
        setLoading(false)
        return
      }

      try {
        const resp = await fetch("/mockTransactions.json")
        const all: UserTransactions[] = await resp.json()
        const found = all.find(u => u.uid === user.uid)
        setTransactions(found ? found.transactions : [])
      } catch (err) {
        console.error("❌ Failed to load transactions:", err)
        setError("Could not load transactions")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [user])

  return (
    <div className="transactions-list">
      <h3>Recent Transactions</h3>

      {loading ? (
        <p>Loading…</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : transactions.length === 0 ? (
        <p>No transactions found</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Coin</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(tx => (
              <tr key={tx.id}>
                <td>{tx.type}</td>
                <td>{tx.coin}</td>
                <td>{tx.amount}</td>
                <td>{tx.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default TransactionsList
